import $ from 'jquery';
import getQuery from './tools/getQuery.js';

const components = [
	require('./components/eventActions'),
	require('./components/gmap'),
	require('./components/priceToggle'),
	require('./components/carousel'),
	require('./components/fancybox'),
	require('./components/animations'),
	require('./components/multislider'),
	require('./components/selectList')
];
const contentload = [
	require('./components/datepicker'),
	require('./components/matchHeights')
];

window.App = {
	query: getQuery(),
	run() {
		// components
		var $target = $(document);
		components.forEach((component) => component.init( $target ));

		// contentload
		$(document)
			.on('contentload', function(event){
				var $target = $(event.target);
				contentload.forEach((component) => component.init( $target ));
			}).trigger('contentload');
	}
};



// WEBPACK FOOTER //
// ./src/js/app.js